import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { Formik, Form, Field } from 'formik'
import _mapValues from 'lodash/mapValues'
import _map from 'lodash/map'
import _range from 'lodash/range'
import _isEqual from 'lodash/isEqual'

import { CustomToggleField, ReactSelectField } from '../../../formik/Fields'
import { OverlayTrigger } from '../../../_library/OverlayTrigger'
import Button from '../../../_library/Button'
import Card from '../../../_library/Card'
import LoadingBar from '../../../_library/LoadingBar'

import {
  // getBrandCreditCards,
  getPaymentPlan,
  createPaymentPlan,
  updatePaymentPlan,
} from '../../../../_common/core/http_services'

import { showAxiosError, showSuccessMessage } from '../../../utils/messenger'
import { ROLES } from '../../../constants/roles'
import { FETCH_EVENT } from '../../../../_common/redux/events/actions'

const PaymentPlanSection = props => {
  const {
    event,
    user: { tfRole },
    FETCH_EVENT,
  } = props

  const initialData = useMemo(
    () => ({
      durationOfInstalments: null,
      numberOfInstalments: null,
      lastInstalment: null,
      orderCancellation: null,
      paymentPlanEnabled: false,
    }),
    [],
  )

  const lastInstalmentOptions = useMemo(
    () =>
      _map(_range(1, 7), item => {
        const label =
          item === 1 || item === 2
            ? item + ' (least recommended)'
            : item === 4
            ? item + ' (most recommended)'
            : item
        return { value: item, label }
      }),
    [],
  )

  let tooltipMessage = ''
  const isPermissionsDenied = event?.hasSales && !ROLES.is_tf_support_admin_or_client_admin(tfRole)

  if (event?.hasSales) {
    tooltipMessage = `Inactive because there is an order associated with this event.`
  } else if (!ROLES.is_tf_support_admin_or_client_admin(tfRole)) {
    tooltipMessage = `You don't have a permission to activate the payment plan.`
  }

  const [paymentPlanData, setPaymentPlanData] = useState(initialData)
  // const [creditCards, setCreditCards] = useState([])
  const [loading, setLoading] = useState(false)
  const [isNewPaymentPlan, setIsNewPaymentPlan] = useState(true)
  const [saveLoading, setSaveLoading] = useState(false)

  // const getCreditCard = useCallback(async () => {
  //   try {
  //     const brandCreditCards = await getBrandCreditCards(owner.id)
  //     setCreditCards(brandCreditCards)
  //   } catch (error) {
  //     showAxiosError(error)
  //   }
  // }, [owner])

  const getPaymentPlanData = useCallback(async () => {
    try {
      const data = await getPaymentPlan(event.id)
      if (!_isEqual(data, initialData)) {
        setIsNewPaymentPlan(false)
      }
      setPaymentPlanData(data)
    } catch (error) {
      showAxiosError(error)
    }
  }, [event.id, initialData])

  const updatePaymentPlanData = useCallback(
    async updatedData => {
      setSaveLoading(true)
      try {
        await updatePaymentPlan(event.id, updatedData)
        showSuccessMessage('Saved')
      } catch (error) {
        showAxiosError(error)
      }
      setSaveLoading(false)
    },
    [event],
  )

  const createPaymentPlanData = useCallback(
    async data => {
      setSaveLoading(true)
      try {
        await createPaymentPlan(event.id, data)
        showSuccessMessage('Saved')
      } catch (error) {
        showAxiosError(error)
      }
      setSaveLoading(false)
    },
    [event],
  )

  const getInitialData = useCallback(async () => {
    setLoading(true)
    // await getCreditCard()
    await getPaymentPlanData()
    setLoading(false)
  }, [getPaymentPlanData])

  useEffect(() => {
    getInitialData()
  }, [getInitialData])

  const handleSave = async values => {
    const paymentPlanData = _mapValues(values, item => (item?.value ? item?.value : item))
    try {
      if (isNewPaymentPlan) {
        await createPaymentPlanData(paymentPlanData)
      } else {
        await updatePaymentPlanData(paymentPlanData)
      }

      FETCH_EVENT(event.id)
    } catch (error) {
      showAxiosError(error)
    }
  }
  // Comented strokes are temporary and should be uncommented after requirenment changes

  // const creditCardinfo = () => {
  //   const defaultCard = _find(creditCards, card => card.isDefault === true)
  //   return (
  //     <div className="card-info-ontainet">
  //       <i className="fa fa-credit-card fa-lg" aria-hidden="true" />
  //       <p className="text">
  //         {defaultCard.type} .... {defaultCard.last4}
  //       </p>
  //     </div>
  //   )
  // }

  return (
    <Card
      icon="fa-money fa-lg"
      overflowWhenOpen="visible"
      className="payment-plan-section"
      title="Payment Plans"
    >
      {loading ? (
        <LoadingBar />
      ) : (
        <Formik
          enableReinitialize
          initialValues={paymentPlanData}
          onSubmit={handleSave}
          validateOnBlur={false}
        >
          {props => {
            const { values, errors, touched } = props
            const validateField = value => (value === null && values.paymentPlanEnabled ? 'Required' : null)
            const isFieldDisabled = isPermissionsDenied || !values.paymentPlanEnabled
            let labelClassName = 'text'
            if (isFieldDisabled) labelClassName += ' disabled'

            return (
              <Form>
                <div className="payment-plan-enable-part">
                  {/* <p className="part-title">Credit Card Details</p> */}
                  <div className="payment-plan-toggle-part">
                    {/* Should be uncommented a bit letter */}
                    {/* {!_isEmpty(creditCards) ? ( */}
                    <OverlayTrigger
                      hideTooltip={!isPermissionsDenied}
                      tooltip={tooltipMessage}
                      id="payment-plan-toggle"
                      delayShow={400}
                      delayHide={10}
                      placement="top"
                    >
                      <div className="payment-plan-toggle">
                        <label>Enable payment plan</label>
                        <Field
                          disabled={isPermissionsDenied}
                          name="paymentPlanEnabled"
                          component={CustomToggleField}
                        />
                      </div>
                    </OverlayTrigger>
                    {/* ) : (
                      <div className="instead-toggle-text-container">
                        <p className="text">In order to enable payment plans, a credit card must be added.</p>
                        <p className="subtext">
                          Please contact the Brand Owner or a Brand Admin to add a credit card.
                        </p>
                      </div>
                    )} */}
                  </div>
                </div>
                {/* <div>
                  <p className="text">
                    TF booking fees for new payment plan orders will be directly charged to this card on
                    weekly basis
                  </p>
                  <p className="subtext">
                    Note: If a payment fails, the payment plan option may be disabled for new plans until the
                    card can be successfully charged
                  </p>
                  {!_isEmpty(creditCards) && values.paymentPlanEnabled ? creditCardinfo() : null}
                </div> */}
                <div className="payment-plan-instalments-part">
                  <p className="part-title">Instalments</p>
                  <div className="all-instalments">
                    <div className="instalments">
                      <p className="text">Please specify the number of instalments and duration</p>
                      <div className="instalments-field-container">
                        <OverlayTrigger
                          hideTooltip={!isPermissionsDenied}
                          tooltip="Inactive because there is an order associated with this event."
                          id="instalments-number"
                          delayShow={400}
                          delayHide={10}
                          placement="top"
                          className={
                            errors.numberOfInstalments && touched.numberOfInstalments
                              ? 'instalments-number error-field'
                              : 'instalments-number'
                          }
                        >
                          <div>
                            <Field
                              validate={validateField}
                              disabled={isFieldDisabled}
                              name="numberOfInstalments"
                              placeholder=""
                              component={ReactSelectField}
                              options={_map(_range(1, 16), item => ({ value: item, label: item }))}
                            />
                          </div>
                        </OverlayTrigger>
                        <OverlayTrigger
                          hideTooltip={!isPermissionsDenied}
                          tooltip="Inactive because there is an order associated with this event."
                          id="instalments-duration"
                          delayShow={400}
                          delayHide={10}
                          placement="top"
                          className={
                            errors.durationOfInstalments && touched.durationOfInstalments
                              ? 'instalments-duration error-field'
                              : 'instalments-duration'
                          }
                        >
                          <div>
                            <Field
                              validate={validateField}
                              disabled={isFieldDisabled}
                              name="durationOfInstalments"
                              placeholder=""
                              component={ReactSelectField}
                              options={[
                                { value: 'weekly', label: 'Weekly' },
                                { value: 'monthly', label: 'Monthly' },
                              ]}
                            />
                          </div>
                        </OverlayTrigger>
                        <p className={labelClassName}>Instalments</p>
                      </div>
                    </div>
                    <div className="last-instalments">
                      <p className="text">When do you want the last instalment to be?</p>
                      <div className="last-instalments-field-container">
                        <OverlayTrigger
                          hideTooltip={!isPermissionsDenied}
                          tooltip="Inactive because there is an order associated with this event."
                          id="last-instalment-number"
                          delayShow={400}
                          delayHide={10}
                          placement="top"
                          className={
                            errors.lastInstalment && touched.lastInstalment
                              ? 'last-instalment-number error-field'
                              : 'last-instalment-number'
                          }
                        >
                          <div>
                            <Field
                              validate={validateField}
                              disabled={isFieldDisabled}
                              placeholder=""
                              name="lastInstalment"
                              options={lastInstalmentOptions}
                              component={ReactSelectField}
                            />
                          </div>
                        </OverlayTrigger>
                        <p className={labelClassName}>Weeks before the event</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="payment-plan-cancelation-part">
                  <p className="part-title">Cancelation</p>
                  <div className="cancelation-content">
                    <div>
                      <p className="text">When do you want to cancel unpaid orders?</p>
                      <p className="subtext">You will retain the first instalment for all canceled plans</p>
                    </div>
                    <div className="cancelation-field-container">
                      <OverlayTrigger
                        hideTooltip={!isPermissionsDenied}
                        tooltip="Inactive because there is an order associated with this event."
                        id="cancelation-number"
                        delayShow={400}
                        delayHide={10}
                        placement="top"
                        className={
                          errors.orderCancellation && touched.orderCancellation
                            ? 'cancelation-number error-field'
                            : 'cancelation-number'
                        }
                      >
                        <div>
                          <Field
                            validate={validateField}
                            disabled={isFieldDisabled}
                            name="orderCancellation"
                            placeholder=""
                            component={ReactSelectField}
                            options={_map(_range(1, 7), item => ({ value: item, label: item }))}
                          />
                        </div>
                      </OverlayTrigger>
                      <p className={labelClassName}>Weeks before the event</p>
                    </div>
                  </div>
                </div>
                <div className="save-button-container">
                  <Button
                    className="btn btn-success btn-lg btn-shadow"
                    type="submit"
                    disabled={isPermissionsDenied}
                    loading={saveLoading}
                  >
                    Save
                  </Button>
                </div>
              </Form>
            )
          }}
        </Formik>
      )}
    </Card>
  )
}

const mapDispatchToProps = {
  FETCH_EVENT,
}

export default connect(null, mapDispatchToProps)(PaymentPlanSection)
